import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useContentCommandApi } from "@/composables/useContentCommandApi";
import type { ExperienceOperationalTranslation } from "@/types/generated/ContentCommandApi";

export type { ExperienceOperationalTranslation };

export const OPERATIONAL_TRANSLATIONS_QUERY_KEY = "experience-operational-translations";

export function useOperationalTranslationsQuery(languageCode?: string) {
  const experienceId = useRouteParams<string>("id");
  const { getExperienceOperationalTranslations } = useContentCommandApi();

  return useQuery({
    queryKey: [OPERATIONAL_TRANSLATIONS_QUERY_KEY, experienceId, languageCode],
    queryFn: async (): Promise<ExperienceOperationalTranslation[]> => {
      const { data } = await getExperienceOperationalTranslations(experienceId.value, languageCode);
      return data;
    },
    enabled: computed(() => !!experienceId.value),
  });
}
